export default __webpack_public_path__ + "static/media/header-2.a9148fde.jpg";